import React, { useMemo, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@material-ui/core/Typography';
import {
  ActionButtonHandle,
  FormPanel,
  RemoteTableField,
  ScrollableSource,
  TableFieldHandle,
  TableFieldToolbarProps,
} from '@eas/common-web';
import { FormTableCount } from '@components/form/table-field/form-table-count';
import { EsFile, Writer } from '@models';
import { useWriterColumns } from './writer-columns';
import { FormFields } from './writer-dialog';
import { WriterToolbar } from './writer-toolbar';

export interface WriterFieldProps {
  disabled: boolean;
  esFile: EsFile | undefined;
  source?: ScrollableSource<Writer>;
}

export function WriterField({ disabled, esFile, source }: WriterFieldProps) {
  const columns = useWriterColumns();

  const tableRef = useRef<TableFieldHandle>(null);
  const editRef = useRef<ActionButtonHandle>(null);

  const ToolbarComponent = useMemo(
    () =>
      function Toolbar(props: TableFieldToolbarProps) {
        return (
          <WriterToolbar
            {...props}
            ref={editRef}
            disabled={disabled}
            esFile={esFile}
          />
        );
      },
    [disabled, esFile]
  );

  if (!source) {
    return <> Missing WRITER_SOURCE </>;
  }

  return (
    <FormPanel
      label={
        <FormattedMessage
          id="ES__WRITERS__PANEL_TITLE"
          defaultMessage="Pisatelé"
        />
      }
      summary={<FormTableCount source={source} />}
    >
      <RemoteTableField
        ref={tableRef}
        source={source}
        columns={columns}
        onRowClick={(_, index) => {
          if (!disabled) {
            tableRef.current?.setSelectedIndex(index);
            editRef.current?.executeAction();
          }
        }}
        maxRows={10}
        ToolbarComponent={ToolbarComponent}
        disabled={disabled}
        showDetailBtnCond={() => true}
        FormFieldsComponent={() => (
          <div style={{ width: 700 }}>
            <Typography variant="body1" style={{ marginBottom: 8 }}>
              <FormattedMessage
                id="ES__WRITERS__FORM_FIELDS__TITLE"
                defaultMessage="Pisatel:"
              />
            </Typography>
            <FormFields />
          </div>
        )}
      />
    </FormPanel>
  );
}
